import { api, ERR_OK } from './config';
import axios from 'axios';

/**
 * 获取课程列表，用于下拉框数据填充
 * @param userId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getCourses(userId) {
  return await axios.post(api.coursesUrl, {
    userId,
  }).then((res) => {
    return res.data;
  });
}

/**
 * 获取库存记录
 * @param userId
 * @param pageIndex
 * @param action
 * @param schoolId
 * @param insNo
 * @param courseId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getStockList(userId, pageIndex = 1, action, schoolId = '', insNo = '', courseId) {
  return await axios.post(api.stockListUrl, {
    userId,
    pageIndex,
    action,
    schoolId,
    insNo,
    courseId,
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    } else {
      return [];
    }
  });
}